import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import ReqPay from "./ReqPay";
import ReqPaySms from "./ReqPaySms";


function ReqPaySelect(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [option, setOption] = useState("none");


    const onBack = () => {

        setOption("none");
    }

    const setEmail = () => {   setOption("email"); }
    const setSMS = () =>   {   setOption("sms"); }



    if(refreshView != props.userData.refreshView)
    {
        setRefreshView(props.userData.refreshView);
        setOption("none");
    }


    if( option == "email")
    {
        return <ReqPay userData={props.userData}  mainView={props.mainView} onBack={onBack}   />
    }

    if( option == "sms")
    {
            return <ReqPaySms userData={props.userData}  mainView={props.mainView} onBack={onBack}    />
    }



    return <div className="block_center">
        
                <div className="block_option" onClick={setEmail}>Wezwania E-mail</div>
                <div className="block_option" onClick={setSMS}>Wezwania SMS</div>

    </div>
}


export default ReqPaySelect;